import React, { useContext, useEffect, useState } from "react";
import { Button, ButtonGroup, Divider, Paper, Stack, Typography } from "@mui/material";
import {
  Add,
  ArrowBack,
  ArrowForward,
  ExpandLess,
  ExpandMore,
  CompareArrows,
  AutoAwesome,
} from "@mui/icons-material";
import { DialogContext, QuestionsContext } from "../../../../../provider/MyContexts";
import InfoForm from "./infoForm/InfoForm";
import { QuestionsDiffDialog1, QuestionsDiffDialog2 } from "../../../../components/MyDialog";
import MyIconButton from "../../../components/MyIconButton";
import { keyframes } from "@emotion/react";

export default function GenToolBar(props: { handleScrollTo: (index: number) => void }) {
  const {
    questions,
    addQuestion,
    baseSheet,
    handleChangeBaseSheet,
    loadSheetData,
    researchInfo,
    selectedItemSheet,
    undo,
    redo,
    autoSetBaseSheet,
  } = useContext(QuestionsContext);

  const [detailOpen, setDetailOpen] = useState(false);

  const { handleDialogClose } = useContext(DialogContext);

  const [diffDialogStep, setDiffDialogStep] = useState(0);

  const [growButton, setGrowButton] = useState(true);

  function handleDialogStep(step: number) {
    setDiffDialogStep(step);
    if (step === 0) {
      handleDialogClose();
    }
  }

  function switchDetailOpen() {
    setDetailOpen((prev) => {
      prev == true && setGrowButton(false);
      return !prev;
    });
  }

  useEffect(() => {
    loadSheetData(baseSheet);
    setDiffDialogStep(0);
  }, [baseSheet]);

  // useEffect(() => {
  //   autoSetBaseSheet();
  // }, []);

  const glow = keyframes`
  0% {
    border-color: rgba(0, 100, 200, 0.4);
    box-shadow: 0 0 2px rgba(0, 100, 200, 0.2);
  }
  50% {
    border-color: rgba(0, 100, 200, 1.0);
    box-shadow: 0 0 6px rgba(0, 100, 200, 0.6);
  }
  100% {
    border-color: rgba(0, 100, 200, 0.4);
    box-shadow: 0 0 2px rgba(0, 100, 200, 0.2);
  }
        `;

  // useEffect(() => {
  //   if (researchInfo.client === "") {
  //     setDetailOpen(true);
  //   }
  // }, []);

  const shouldGlow =
    (researchInfo.client === "" || researchInfo.theme == "") && !detailOpen && growButton;

  return (
    <React.Fragment>
      <Paper
        variant="outlined"
        sx={{
          p: 1,
          position: "sticky",
          top: 0,
          zIndex: 1,
        }}
      >
        <Stack direction={"row"} justifyContent={"space-between"} spacing={0.5}>
          <Stack justifyContent={"center"} alignItems={"center"} flex={1}>
            <Typography variant="label_S">ベースにするシート</Typography>
            <ButtonGroup aria-label="Basic button group">
              <Button
                size="small"
                variant={baseSheet == "form" ? "contained" : "outlined"}
                onClick={() => handleChangeBaseSheet("form")}
              >
                <Typography variant="button">調査票</Typography>
              </Button>
              <Button
                size="small"
                variant={baseSheet == "item" ? "contained" : "outlined"}
                onClick={() => handleChangeBaseSheet("item")}
                disabled={!selectedItemSheet}
              >
                <Typography variant="button">項目一覧</Typography>
              </Button>
            </ButtonGroup>
          </Stack>
          <Divider orientation="vertical" flexItem />
          <Stack direction={"row"} spacing={0.5}>
            {[
              { label: "もどる", icon: <ArrowBack fontSize="small" /> },
              { label: "すすむ", icon: <ArrowForward fontSize="small" /> },
            ].map((item, index) => {
              return (
                <Button
                  key={index}
                  variant="text"
                  size="small"
                  disabled={questions.length === 0}
                  sx={{
                    width: 40,
                    display: "flex",
                    flexDirection: "column",
                  }}
                  onClick={() => {
                    if (item.label === "もどる") {
                      undo();
                    } else {
                      redo();
                    }
                  }}
                >
                  {item.icon}
                  <Typography variant="label_S">{item.label}</Typography>
                </Button>
              );
            })}
          </Stack>
          <Divider orientation="vertical" flexItem />

          <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={0.5}>
            <MyIconButton
              icon={<Add />}
              label="設問追加"
              clickFunction={async () => {
                await addQuestion();
                props.handleScrollTo(questions.length - 1);
              }}
              disabled={false}
            />
            {baseSheet == "item" ? (
              <MyIconButton
                icon={<AutoAwesome />}
                label="一括生成"
                clickFunction={async () => {}}
                disabled={true}
              />
            ) : (
              <></>
            )}

            <MyIconButton
              icon={<CompareArrows />}
              label="差分CHK"
              clickFunction={async () => {
                handleDialogStep(1);
                // syncAndInsertQuestions();
              }}
              // disabled={true}
            />
            <Button
              onClick={switchDetailOpen}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                color: "primary.main",
                // border: shouldGlow ? "1px solid rgba(0, 100, 200, 0.3)" : "none",
                // animation: shouldGlow ? `${borderPulse} 2s infinite` : "none",

                border: shouldGlow ? "1.5px solid rgba(0, 100, 200, 0.4)" : "none",
                animation: shouldGlow ? `${glow} 2s ease-in-out infinite` : "none",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                backgroundColor: "transparent",
                boxShadow: shouldGlow ? "0 0 2px rgba(0, 100, 200, 0.2)" : "none",
              }}
            >
              <Typography variant="label_S">設定</Typography>
              {detailOpen ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
            </Button>
          </Stack>
        </Stack>
        {detailOpen && <InfoForm />}
      </Paper>
      <QuestionsDiffDialog1
        open={diffDialogStep == 1}
        handleClose={() => setDiffDialogStep(0)}
        handleDialogStep={handleDialogStep}
      />
      <QuestionsDiffDialog2
        open={diffDialogStep == 2}
        handleClose={() => setDiffDialogStep(0)}
        handleDialogStep={handleDialogStep}
        dialogStep={diffDialogStep}
      />
    </React.Fragment>
  );
}
